import { render, staticRenderFns } from "./highPoweFour.vue?vue&type=template&id=2f919b50&scoped=true"
import script from "./highPoweFour.vue?vue&type=script&lang=js"
export * from "./highPoweFour.vue?vue&type=script&lang=js"
import style0 from "./highPoweFour.vue?vue&type=style&index=0&id=2f919b50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f919b50",
  null
  
)

export default component.exports